module.exports = __webpack_public_path__ + "static/media/wordpress.a23d136a.svg";